<div class="data-spinner" id="tos-loader">
  <mat-spinner color="accent"></mat-spinner>
</div>

<prof-topnav-onetrust [title]="title"></prof-topnav-onetrust>
<!-- OneTrust Privacy Notice start -->

<!-- Language Drop-down elements that will control in which language notice is displayed -->
<div class="otnotice-language-dropdown-container">
  <select
    id="otnotice-language-dropdown"
    aria-label="language selector"
  ></select>
</div>

<!-- Container in which the privacy notice will be rendered -->
<div id="otnotice-ff070f5b-5bfb-40f7-89ea-7672b2ea689e" class="otnotice"></div>

<!-- OneTrust Privacy Notice end -->
